// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/unlink.js';

import { paths } from '../generated/unlink';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('unlink', Original, paths);
